import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { axiosErrorHandler } from 'common/helpers/axios.helper';
import { AppDispatch, RootState } from 'app/store';
import { ISeller, ISellerListParams } from 'entities/Seller/Seller.models';
import { sellerTransport } from 'entities/Seller/Seller.transport';

interface IState {
  sellerList: ISeller[];
  isSellerLoading: boolean;
}

const initialState: IState = {
  sellerList: [],
  isSellerLoading: false,
};

export const sellerSlice = createSlice({
  name: 'seller',
  initialState,
  reducers: {
    setSellerList(state, action: PayloadAction<ISeller[]>) {
      state.sellerList = action.payload;
    },
    setIsSellerLoading(state, action: PayloadAction<boolean>) {
      state.isSellerLoading = action.payload;
    },
  },
});

export const { setSellerList, setIsSellerLoading } = sellerSlice.actions;

export const selectSellerList = (state: RootState) => state.seller.sellerList;
export const selectIsSellerLoading = (state: RootState) => state.seller.isSellerLoading;

export const sellerReducer = sellerSlice.reducer;

export const getSellerList = (params: ISellerListParams) => async (dispatch: AppDispatch) => {
  dispatch(setIsSellerLoading(true));

  try {
    const response = await sellerTransport.get(params);
    dispatch(setSellerList(response.data));
  } catch (error) {
    axiosErrorHandler(error);
  } finally {
    dispatch(setIsSellerLoading(false));
  }
};
